import React, { useEffect, useState } from 'react';
import MarketHomeHeader from 'components/pages/market/home/MarketHomeHeader';
import styled from 'styled-components';
import MarketListView from 'components/pages/market/home/MarketListView';
import MarketTabBar, { MARKET_TABS } from 'components/pages/market/home/MarketTabBar';
import useMarket from 'hooks/useMarket';
import PrepareView from 'components/pages/market/home/PrepareView';
import useUser from 'hooks/useUser';
import { getCookie } from 'components/common/cookie';
import authCheck from 'components/common/useAuthCheck';
import { useNavigate } from 'react-router-dom';

const MarketHome = () => {
   const [tabIndex, setTabIndex] = useState(0);
   const { resetMarketItems } = useMarket();
   const handleTabIndex = index => {
      setTabIndex(index);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      resetMarketItems();
   };
   const checkAccessLevel = () => {
      const isAccessible = authCheck('NORMAL');
      console.log(isAccessible);
      if (isAccessible) return;
      navigate('/login');
   };

   const { getUserInfo } = useUser();
   const navigate = useNavigate();

   useEffect(() => {
      checkAccessLevel();
      getUserInfo();
      getUserId();
   }, []);

   return (
      <React.Fragment>
         <MarketHomeHeader />
         <MarketTabBar tabIndex={tabIndex} handleTabIndex={handleTabIndex} />

         {tabIndex === 0 && (
            <MarketListView key={MARKET_TABS[0].name} market={MARKET_TABS[0].name} />
         )}
         {tabIndex === 1 && <PrepareView />}
         {tabIndex === 2 && (
            <MarketListView key={MARKET_TABS[2].name} market={MARKET_TABS[2].name} />
         )}
      </React.Fragment>
   );
};

export default React.memo(MarketHome);

export const MOCK_USER_ID = 1;
export const decodeJwt = token => {
   const base64Url = token.split('.')[1];
   const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
   const jsonPayload = decodeURIComponent(
      window
         .atob(base64)
         .split('')
         .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
         })
         .join(''),
   );
   return JSON.parse(jsonPayload);
};
export const getUserId = () => {
   const userId = getCookie('userId');
   const hasUserId = userId && userId !== 'undefined' && userId !== 'null';

   if (!hasUserId) return MOCK_USER_ID;
   try {
      return Number(userId);
   } catch (e) {
      return MOCK_USER_ID;
   }
};

export const FilterType = {
   recNum: '추천순',
   pageView: '조회순',
   favor_cnt: '찜많은순',
};

export const MarketInfoWrapper = styled.div`
   display: flex;
   align-items: center;
   padding: 16px 16px;
   justify-content: space-between;
   overflow: hidden;
`;

export const Text = styled.div`
   display: flex;
   flex-direction: row;
   p {
      font-size: 0.75rem;
      font-weight: 400;
   }
   .markettext {
      font-weight: 700;
      color: #ff7a00;
   }
`;

export const Categories = styled.p`
   font-size: 0.75rem;
   font-weight: 500;
   color: #222529;
`;
